// Mock data for Everyone's Budget clone (frontend-only)

export const announcement = "Unbeatable Prices. Local Pick-Up Only. All Sales Final.";

export const products = [
  {
    id: "womens-large-graphic-t-shirts",
    name: "Women's large graphic t-shirts",
    price: 4.87,
    image: "https://jbkwltedsuwcgdldcvsp.supabase.co/storage/v1/object/public/media/uploads/1787000272156-ogzeeh7a-2010.png",
    description: "Women's mix graphic t-shirts",
    category: "clothing",
    subcollection: "t-shirts",
    featured: true,
    inStock: true,
  },
  {
    id: "woman-xl-makes-graphic-t-shirts",
    name: "Woman XL makes graphic t-shirts",
    price: 4.87,
    image: "https://jbkwltedsuwcgdldcvsp.supabase.co/storage/v1/object/public/media/uploads/1787000048125-v4s4pi7o-2009.png",
    description: "Woman XL mixed graphic t-shirts, assorted prints.",
    category: "clothing",
    subcollection: "t-shirts",
    featured: true,
    inStock: true,
  },
  {
    id: "graphic-t-shirts",
    name: "Medium graphic t-shirts",
    price: 4.87,
    image: "https://jbkwltedsuwcgdldcvsp.supabase.co/storage/v1/object/public/media/uploads/1786999205974-yafnqfkz-2007.png",
    description: "Medium graphic t-shirts, assorted prints.",
    category: "clothing",
    subcollection: "t-shirts",
    featured: false,
    inStock: true,
  },
  {
    id: "t-shirts",
    name: "Blank T Shirts",
    price: 7.86,
    image: "https://jbkwltedsuwcgdldcvsp.supabase.co/storage/v1/object/public/media/uploads/1781059777664-zq56fe48-1781059460596.png",
    description: "High quality blank t-shirts, essential basics.",
    category: "clothing",
    subcollection: "t-shirts",
    featured: false,
    inStock: true,
  },
  // ---- Photography Services (listed as bookable products) ----
  {
    id: "community-mini-session",
    name: "20-Minute Community Mini Session",
    price: 86.12,
    image: "https://images.unsplash.com/photo-1685580388390-576100ae9ce3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxmYW1pbHklMjBwb3J0cmFpdCUyMG91dGRvb3J8ZW58MHx8fHwxNzg4MDkzNTA1fDA&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1685580388390-576100ae9ce3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxmYW1pbHklMjBwb3J0cmFpdCUyMG91dGRvb3J8ZW58MHx8fHwxNzg4MDkzNTA1fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1742522211724-3425d697bbf0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxmYW1pbHklMjBwb3J0cmFpdCUyMG91dGRvb3J8ZW58MHx8fHwxNzg4MDkzNTA1fDA&ixlib=rb-4.1.0&q=85",
    ],
    category: "photography",
    subcollection: "portraits",
    featured: false,
    inStock: true,
    type: "service",
    tagline: "Families, Kids & Couples",
    description: "Fast, high-quality mini sessions at local Mississauga spots like Kariya Park or Erindale Park \u2014 great photos for a holiday card or living room frame without a huge time or financial commitment.",
    variants: [
      { name: "Base \u2014 5 edited photos", price: 86.12 },
      { name: "Upgraded \u2014 10 edited photos", price: 106.12 },
    ],
    deliverables: [
      "20-minute outdoor session",
      "5\u201310 professionally edited digital photos",
      "Delivered via a private online gallery",
    ],
    location: "Local Mississauga parks (finalized via email)",
    turnaround: "Photos delivered within 5 days",
  },
  {
    id: "professional-headshots",
    name: "Professional Headshots",
    price: 68.86,
    image: "https://images.unsplash.com/photo-1627161683077-e34782c24d81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3ODgwOTM1MDR8MA&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1627161683077-e34782c24d81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3ODgwOTM1MDR8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3ODgwOTM1MDR8MA&ixlib=rb-4.1.0&q=85",
    ],
    category: "photography",
    subcollection: "headshots",
    featured: false,
    inStock: true,
    type: "service",
    tagline: "Job Seekers & Local Students",
    description: "Upgrade your LinkedIn profile, resume, or portfolio. Perfect for mature students entering the workforce or local professionals who need a quick, affordable upgrade.",
    variants: [
      { name: "15-minute session \u2014 2 edits", price: 68.86 },
      { name: "15-minute session \u2014 3 edits", price: 84.86 },
    ],
    deliverables: [
      "15-minute session (outdoor or simple backdrop)",
      "2\u20133 highly polished digital edits",
      "Delivered via a private online gallery",
    ],
    location: "Outdoor or simple backdrop (finalized via email)",
    turnaround: "Photos delivered within 5 days",
  },
  {
    id: "small-business-hustler",
    name: "Small Business \"Hustler\" Package",
    price: 125,
    image: "https://images.unsplash.com/photo-1563170351-be82bc888aa4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxwcm9kdWN0JTIwcGhvdG9ncmFwaHl8ZW58MHx8fHwxNzg4MDkzNTA0fDA&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1563170351-be82bc888aa4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxwcm9kdWN0JTIwcGhvdG9ncmFwaHl8ZW58MHx8fHwxNzg4MDkzNTA0fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1611930022073-b7a4ba5fcccd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxwcm9kdWN0JTIwcGhvdG9ncmFwaHl8ZW58MHx8fHwxNzg4MDkzNTA0fDA&ixlib=rb-4.1.0&q=85",
    ],
    category: "photography",
    subcollection: "product-brand",
    featured: false,
    inStock: true,
    type: "service",
    tagline: "Product & Brand Photos",
    description: "For local entrepreneurs, contractors, or artists who can't afford big commercial agencies. Shoot your products or you at work.",
    variants: [
      { name: "1-hour session \u2014 15 edited photos", price: 125 },
      { name: "Product-only \u2014 flat rate per item", price: 15 },
    ],
    deliverables: [
      "1-hour session shooting products or you at work",
      "15 professionally edited photos",
      "Or flat $15 per item for product-only shots",
    ],
    location: "Your location or agreed spot (finalized via email)",
    turnaround: "Photos delivered within 5 days",
  },
  {
    id: "milestones-events",
    name: "Small Milestones & Event Coverage",
    price: 145,
    image: "https://images.unsplash.com/photo-1639765766830-d829d2fe4219?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxncmFkdWF0aW9uJTIwY2FuZGlkfGVufDB8fHx8MTc4ODA5MzUwNXww&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1639765766830-d829d2fe4219?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxncmFkdWF0aW9uJTIwY2FuZGlkfGVufDB8fHx8MTc4ODA5MzUwNXww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1525921429624-479b6a26d84d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxncmFkdWF0aW9uJTIwY2FuZGlkfGVufDB8fHx8MTc4ODA5MzUwNXww&ixlib=rb-4.1.0&q=85",
    ],
    category: "photography",
    subcollection: "events",
    featured: false,
    inStock: true,
    type: "service",
    tagline: "Sports, Birthdays & Graduations",
    description: "Candid and posed coverage of youth sporting events, small birthdays, or graduations.",
    variants: [
      { name: "1 hour", price: 145 },
      { name: "2 hours", price: 280 },
    ],
    deliverables: [
      "Candid and posed event coverage",
      "Full set of edited digital photos",
      "Delivered via a private online gallery",
    ],
    location: "Your event location (finalized via email)",
    turnaround: "Photos delivered within 5 days",
  },
];

export const categories = [
  {
    id: "clothing",
    name: "Clothing",
    image: "https://jbkwltedsuwcgdldcvsp.supabase.co/storage/v1/object/public/media/uploads/1782039111600-6vvb85m6-1251.jpg",
    subcollections: [{ id: "t-shirts", name: "T shirts" }],
  },
  {
    id: "photography",
    name: "Photography Services",
    image: "https://images.unsplash.com/photo-1742522211724-3425d697bbf0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxmYW1pbHklMjBwb3J0cmFpdCUyMG91dGRvb3J8ZW58MHx8fHwxNzg4MDkzNTA1fDA&ixlib=rb-4.1.0&q=85",
    subcollections: [
      { id: "portraits", name: "Portraits" },
      { id: "headshots", name: "Headshots" },
      { id: "product-brand", name: "Product & Brand" },
      { id: "events", name: "Events" },
    ],
  },
];

// Non-refundable deposit + booking note shared across all photography services
export const bookingInfo = {
  deposit: 27,
  note: "After checkout, we'll email you within 48 hours to confirm your preferred date, time, and location.",
  digitalNote: "Digital service \u2014 no shipping and no in-person pick-up required.",
};

export const infoPages = {
  sizing: {
    title: "Sizing Guide",
    body: [
      "Our apparel follows standard North American sizing. Because inventory rotates frequently, exact fits may vary by batch.",
      "S fits chest 34-36in, M fits 38-40in, L fits 42-44in, XL fits 46-48in.",
      "When in doubt, size up. All sales are final so please choose carefully.",
    ],
  },
  "local-pickup": {
    title: "Pick-Up & Order Policy",
    body: [
      "All orders are pick-up only. Pick-up location: 85 Acorn Place, Mississauga, ON. We do not offer shipping.",
      "Once your order is placed, you'll receive a confirmation with a pick-up window.",
      "Please bring your order number and a valid ID to 85 Acorn Place to collect your items.",
    ],
  },
  returns: {
    title: "Return Policy (All Sales Final)",
    body: [
      "All sales are final. We do not accept returns, refunds, or exchanges.",
      "Please review product details and sizing carefully before purchasing.",
      "If an item is defective, contact us within 24 hours of pick-up.",
    ],
  },
  care: {
    title: "Care Instructions",
    body: [
      "Machine wash cold with like colors. Do not bleach.",
      "Tumble dry low or hang dry to preserve prints.",
      "Iron inside-out on low heat. Do not iron directly on graphics.",
    ],
  },
  faq: {
    title: "FAQ",
    body: [
      "Q: Do you ship? A: No, we are pick-up only in Mississauga.",
      "Q: Can I return items? A: All sales are final.",
      "Q: How do I pay? A: Payment is collected at checkout online, pick-up in person.",
    ],
  },
  contact: {
    title: "Contact Us",
    body: [
      "Have a question? Reach out and we'll get back to you within 1-2 business days.",
      "Email: info@everyonesbudget.ca",
      "Pick-up location: 85 Acorn Place, Mississauga, ON (by appointment).",
    ],
  },
  about: {
    title: "About Us",
    body: [
      "Everyone's Budget is Mississauga's budget-friendly stop for apparel, footwear, and home goods.",
      "We believe high quality shouldn't come with a high price. Our mission is to serve the community with unbeatable prices.",
      "Local pick-up only. All sales final.",
    ],
  },
  "customer-service": {
    title: "Customer Service",
    body: [
      "We're here to help with orders, pick-up scheduling, and product questions.",
      "Email info@everyonesbudget.ca and include your order number for faster service.",
    ],
  },
  privacy: {
    title: "Privacy Policy",
    body: [
      "We respect your privacy. We only collect information needed to process and fulfill your orders.",
      "We never sell your personal data to third parties.",
    ],
  },
};
